import React, { PureComponent } from 'react';
import { withRouter } from '../../common/utils/NavigationWrapper';
import { IconButton, TextField, Button, Tooltip, Zoom } from '@mui/material';
import { Group as GroupIcon, Delete as DeleteIcon, Block as NoneIcon } from '@mui/icons-material';

import Tile from '../../common/components/Tile/Tile';
import PageContainer from '../../common/components/Page/PageContainer';
import TableEnhancedContainer from '../../common/components/TableEnhanced/TableEnhancedContainer';
import PermissionsCheck from '../../common/components/PermissionsCheck/PermissionsCheck';
import PermissionsEnum from '../../common/constants/PermissionsEnum';
import AddUserDialog from './components/AddUserDialog';
import AddInstrumentDialog from './components/AddInstrumentDialog';
import ConfirmationDialog from '../../common/components/ConfirmationDialog/ConfirmationDialog';
import './GroupDetails.css';

class GroupDetails extends PureComponent {
  constructor(props) {
    super(props);
    this.usersTableColumnsConfig = [
      {
        name: 'Username',
        key: 'Username',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Role',
        key: 'RoleName',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Is default user',
        key: 'DefaultUser',
        type: 'boolean',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Actions',
        key: 'Actions',
        type: 'markup',
        markup: (el, col, elIndex, colIndex) => {
          return el.Editable ? (
            <PermissionsCheck permission={PermissionsEnum.EDIT_GROUPS}>
              <div>
                <Tooltip disableInteractive TransitionComponent={Zoom} title="Delete">
                  <IconButton
                    size="large"
                    key={1}
                    style={{}}
                    onClick={() => {
                      return props.onRemoveUserCallback(el);
                    }}
                    data-qa="qa-delete-button"
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </PermissionsCheck>
          ) : (
            <div>
              <PermissionsCheck permission={PermissionsEnum.EDIT_GROUPS}>
                <IconButton disabled={true} size="large">
                  <NoneIcon />
                </IconButton>
              </PermissionsCheck>
            </div>
          );
        },
        style: { width: '10rem' },
        visible: true,
        filterable: false,
        sortable: false,
      },
    ];

    this.instrumentsColumnsConfig = [
      {
        name: 'Serial number',
        key: 'SerialNumber',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Type',
        key: 'Type',
        type: 'string',
        visible: true,
        filterable: true,
        sortable: true,
      },
      {
        name: 'Actions',
        key: 'Actions',
        type: 'markup',
        markup: (el, col, elIndex, colIndex) => {
          return (
            <PermissionsCheck permission={PermissionsEnum.REMOVE_INSTRUMENTS_FROM_GROUP}>
              <div>
                <Tooltip disableInteractive TransitionComponent={Zoom} title="Delete">
                  <IconButton
                    size="large"
                    key={1}
                    onClick={(event) => {
                      return props.onRemoveInstrumentCallback(event, el);
                    }}
                  >
                    <DeleteIcon />
                  </IconButton>
                </Tooltip>
              </div>
            </PermissionsCheck>
          );
        },
        style: { width: '10rem' },
        visible: true,
        filterable: false,
        sortable: false,
      },
    ];
  }

  render() {
    return (
      <PageContainer pageName="group-details">
        <ConfirmationDialog
          onClickCancel={this.props.showRemoveUserConfirmDialog.cancel}
          onClickMainAction={this.props.showRemoveUserConfirmDialog.action}
          open={this.props.showRemoveUserConfirmDialog.show}
          messageToConfirm={this.props.messageToConfirmForRemovingUser}
          title={this.props.showRemoveUserConfirmDialog.title}
          mainActionLabel={this.props.showRemoveUserConfirmDialog.mainActionLabel}
          disableMainAction={this.props.showRemoveUserConfirmDialog.disableMainAction}
        />
        <ConfirmationDialog
          onClickCancel={this.props.showRemoveInstrumentConfirmDialog.cancel}
          onClickMainAction={this.props.showRemoveInstrumentConfirmDialog.action}
          open={this.props.showRemoveInstrumentConfirmDialog.show}
          messageToConfirm={this.props.messageToConfirmForRemovingInstrument}
          title={this.props.showRemoveInstrumentConfirmDialog.title}
          mainActionLabel={this.props.showRemoveInstrumentConfirmDialog.mainActionLabel}
          disableMainAction={this.props.showRemoveInstrumentConfirmDialog.disableMainAction}
        />
        <ConfirmationDialog
          onClickCancel={this.props.showMoveInstrumentConfirmDialog.cancel}
          onClickMainAction={this.props.showMoveInstrumentConfirmDialog.action}
          open={this.props.showMoveInstrumentConfirmDialog.show}
          messageToConfirm={this.props.messageToConfirmForMovingInstrument}
          title={this.props.showMoveInstrumentConfirmDialog.title}
          mainActionLabel={this.props.showMoveInstrumentConfirmDialog.mainActionLabel}
          disableMainAction={this.props.showMoveInstrumentConfirmDialog.disableMainAction}
        />
        <AddUserDialog
          onClickCancel={this.props.showAddUserDialog.cancel}
          onClickMainAction={this.props.showAddUserDialog.action}
          open={this.props.showAddUserDialog.show}
          disableMainAction={this.props.showAddUserDialog.disableMainAction}
          assignableUsers={this.props.assignableUsers}
          selectedUserId={this.props.selectedUserId}
          handleSelectedUser={this.props.handleSelectedUser}
          selectedUserEmail={this.props.selectedUserEmail}
          handleSelectedUserEmail={this.props.handleSelectedUserEmail}
          emailErrorMessage={this.props.emailErrorMessage}
        />
        <AddInstrumentDialog
          onClickCancel={this.props.showAddInstrumentDialog.cancel}
          onClickMainAction={this.props.showAddInstrumentDialog.action}
          open={this.props.showAddInstrumentDialog.show}
          disableMainAction={this.props.showAddInstrumentDialog.disableMainAction}
          selectedInstrument={this.props.selectedInstrument}
          handleSelectedInstrument={this.props.handleSelectedInstrument}
          assignableInstruments={this.props.assignableInstruments}
        />
        <Tile
          className="u-mb-full"
          title={`Details of group "${this.props.group.Name}"`}
          TitleIcon={GroupIcon}
          helpTag="group_details-group"
        >
          <div className="u-fx u-fx-space-between u-fx-align-end u-mb-full">
            <PermissionsCheck permission={PermissionsEnum.EDIT_GROUPS}>
              <TextField
                variant="standard"
                data-qa="qa-editGroupName"
                label="Group name"
                error={this.props.updateGroupErrorText !== ''}
                helperText={this.props.updateGroupErrorText}
                style={{ width: '100%' }}
                value={this.props.group.Name}
                onChange={(event) => this.props.onChangeCallback('Name', event.target.value)}
              />
            </PermissionsCheck>
            <PermissionsCheck permission={PermissionsEnum.EDIT_GROUPS} hasPermission={false}>
              <span>{this.props.group.Name}</span>
            </PermissionsCheck>
            <PermissionsCheck permission={PermissionsEnum.EDIT_GROUPS}>
              <Button
                variant="contained"
                className="u-ml-full"
                data-qa="qa-saveGroupName"
                color="primary"
                onClick={this.props.onSubmitChangeGroupName}
                disabled={this.props.updateGroupErrorText !== ''}
              >
                SAVE
              </Button>
            </PermissionsCheck>
          </div>
        </Tile>

        <Tile
          className="u-mb-full"
          title={`Users of group "${this.props.group.Name}"`}
          TitleIcon={GroupIcon}
          helpTag="group_details-users"
          RightContent={
            <div>
              <PermissionsCheck permission={PermissionsEnum.EDIT_GROUPS}>
                <Button
                  variant="contained"
                  data-qa="qa-addUserToGroup"
                  className="u-ml-double"
                  color="primary"
                  onClick={() => this.props.openAddUserDialogCallback('')}
                >
                  Add user
                </Button>
              </PermissionsCheck>
            </div>
          }
        >
          <TableEnhancedContainer
            data={this.props.users}
            columns={this.usersTableColumnsConfig}
            enableHideColumns={false}
            enableActionButtons={false}
            qaTag="qa-table-users"
          />
        </Tile>

        <Tile
          title={`Instruments of group "${this.props.group.Name}"`}
          TitleIcon={GroupIcon}
          helpTag="group_details-instruments"
          RightContent={
            <div>
              <PermissionsCheck permission={PermissionsEnum.EDIT_GROUPS}>
                <Button
                  variant="contained"
                  data-qa="qa-addInstrumentToGroup"
                  className="u-ml-double"
                  color="primary"
                  onClick={() => this.props.openAddInstrumentDialogCallback('')}
                >
                  Add instrument
                </Button>
              </PermissionsCheck>
            </div>
          }
        >
          <TableEnhancedContainer
            data={this.props.instruments}
            columns={this.instrumentsColumnsConfig}
            enableHideColumns={false}
            enableActionButtons={false}
            qaTag="qa-table-instruments"
            onClickRow={this.onClickRow}
          />
        </Tile>
      </PageContainer>
    );
  }

  onClickRow = (el) => {
    const { navigate } = this.props;
    navigate(`/instrument-details/${el.SerialNumber}`);
  };
}

export default withRouter(GroupDetails);
